
export default {
  name:"validationNeL",
    components:{
    },
    setup() {
  }
    
};
